import React, { useState, useEffect } from "react";
import { Stack, Input, FormLabel, Box, Image } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";
import { formatDate } from "utils/dateFormatter";
import CategorySelect from "./CategoryList";

const EditHelpTopicDrawer = ({ isOpen, onClose, helpTopic, onUpdateHelpTopic }) => {
  const [formData, setFormData] = useState(helpTopic || {});
  const [isEditing, setIsEditing] = useState(false);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const buildImageUrl = (baseUrl, path) => {
    if (!baseUrl || !path) return null;

    const cleanBase = baseUrl.replace(/\/$/, "");
    const cleanPath = path.replace(/^\/+/, "");

    return `${cleanBase}/${cleanPath}`;
  };


  // Reset formData whenever helpTopic changes
  useEffect(() => {
    if (helpTopic) setFormData(helpTopic);
  }, [helpTopic]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, image: e.target.files[0] }));
  };

  const handleToggleEdit = async () => {
    if (isEditing) {
      const formDataToSend = new FormData();
      formDataToSend.append("title", formData.title);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("category", formData.category);

      if (formData.image) {
        formDataToSend.append("image", formData.image);
      }

      const updatedTopic = await onUpdateHelpTopic(helpTopic.topic_id, formDataToSend);
      if (updatedTopic.success && updatedTopic.data) {
        setFormData(updatedTopic.data);
      }
    }
    setIsEditing(!isEditing);
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>{isEditing ? "Edit Help Topic" : "View Help Topic"}</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Title"
            name="title"
            value={formData.title || ""}
            onChange={handleInputChange}
            placeholder="Enter topic title"
            isReadOnly={!isEditing}
          />

          <ReusableInput
            label="Category"
            name="category"
            value={formData.category || ""}
            onChange={handleInputChange}
            placeholder="Enter topic category"
            isReadOnly={!isEditing}
          />

          <ReusableInput
            label="Description"
            name="description"
            value={formData.description || ""}
            onChange={handleInputChange}
            placeholder="Enter message or description"
            type="textarea"
            isReadOnly={!isEditing}
          />

          {/* Display current image if available and not editing */}
          {formData.image && !isEditing && (
            <Box mb={4}>
              <Image
                src={buildImageUrl(BASE_URL, formData.image)}
                alt={formData.title}
                maxW="100%"
              />

            </Box>
          )}

          <FormLabel>Image</FormLabel>
          <Input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            isDisabled={!isEditing}
          />

          <ReusableInput
            label="Date Added"
            name="dateAdded"
            value={formatDate(formData?.created_at) || ""}
            isReadOnly
            placeholder="Auto-generated"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton fontSize="15px" width="100px" height="40px" onClick={onClose}>
            Cancel
          </GradientButton>
          <GradientButton fontSize="15px" width="100px" height="40px" onClick={handleToggleEdit}>
            {isEditing ? "Save" : "Edit"}
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditHelpTopicDrawer;
